import React, { Fragment, useMemo } from "react";
// import clsx from "clsx";
import {
  BarChart,
  Bar,
  // Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
} from "recharts";
import {
  Metric,
  // selectFormat,
  // StandardTooltip,
  SOCIALS_COLORS,
} from "./../Utils/Utils.js";
import Heading from "../Elements/Heading.js";

const Header = ({ data }) => (
  <Fragment>
    <Heading size={5} className={"mb-2"}>
      {data.label}
    </Heading>
    <div className="mb-2 d-flex">
      <div className="mr-2">
        <Metric size="lg" type={data.type} value={data.total.value} />
      </div>
    </div>
  </Fragment>
);

const Cells = ({ widgets }) => (
  <div className="row prime-series-social__separator">
    {widgets.map((data, i) => (
      <div
        className="col-6 col-lg-3 prime-series-social__summary-widget"
        key={`${data.label}_${i}`}
      >
        {data.label !== "Hashtags" && <Header data={data} />}
        {data.charts && <Charts data={data.charts} type={data.type} />}
        <hr className="social-performance__hr--divider" />
      </div>
    ))}
  </div>
);

const Charts = ({ data, type }) => {
  return (
    <>
      {data.map((chart, index) => {
        return (
          <Fragment key={`${chart.name}_${index}`}>
            <div className="flex-row d-flex align-items-center">
              <span className="ml-0 mr-1 trend__label text-capitalize">
                {chart.name}
              </span>
              <Metric size="xs" type={type} {...chart.total} />
            </div>

            {data && (
              <ResponsiveContainer height={35}>
                <BarChart
                  data={chart.data}
                  layout="vertical"
                  width={100}
                  height={15}
                  margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
                  barCategoryGap={0}
                >
                  {/* <Tooltip
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                    content={
                      <StandardTooltip
                        render={({ data }) => {
                          const payload = chart.data;
                          if (payload !== null) {
                            // beucause the payload always return 1 element.. we get it
                            const tooltipData = payload[0];
                            // we create the tooltips based on the keys of the object `tooltipData`, however, we ignore the "total" attribute
                            // get the attributes/values in an array of key/value pairs
                            let tooltips = Object.entries(tooltipData)
                              // defines which attribute should be removed from the list
                              .filter((t) => t[0] !== "total")
                              // map the key/value pair as tooltip (eg. [ 'organic', 41682376 ])
                              .map((t, idx) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={idx}
                                >
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{
                                        background:
                                          SOCIALS_COLORS[
                                            chart.name.toLowerCase()
                                          ][idx],
                                      }}
                                    />
                              
                                    <span
                                      className={clsx(
                                        "standard-tooltip__key",
                                        "text-capitalize"
                                      )}
                                    >
                                      {t[0]}
                                    </span>
                                  </span>
                                  <span className="standard-tooltip__value">
                                
                                    {selectFormat(type, t[1])}
                                  </span>
                                </div>
                              ));

                            return (
                              <div className="standard-tooltip">
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header text-capitalize">
                                    {chart.name}
                                  </span>
                                </header>
                                <main className="standard-tooltip__main">
                                  {tooltips}
                                </main>
                              </div>
                            );
                          }
                        }}
                      />
                    }
                  /> */}
                  <XAxis type="number" hide />
                  <YAxis type="category" hide />
                  <Bar
                    stackId="stacked"
                    dataKey="value"
                    fill={SOCIALS_COLORS[chart.name.toLowerCase()][0]}
                  />
                  <Bar
                    stackId="stacked"
                    dataKey="total"
                    fill={SOCIALS_COLORS[chart.name.toLowerCase()][1]}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

const WorldCupSocialSummary = ({ data: { cells } }) => {
  const cellsWithoutHashtags = useMemo(
    () => cells.filter((cell) => cell.label !== "Hashtags"),
    [cells]
  );

  return (
    <section>
      <Cells widgets={cellsWithoutHashtags} />
    </section>
  );
};

export default WorldCupSocialSummary;
